import { HOST_EVENT_KEYS, toHostEventName } from "./constants.js";
import { isCommandSettledDetail, } from "./host-event-contract.js";
const DEFAULT_SETTLEMENT_TIMEOUT_MS = 30_000;
export const COMMAND_SETTLEMENT_TIMEOUT_CODE = "COMMAND_SETTLEMENT_TIMEOUT";
export class CommandSettlementError extends Error {
    code;
    requestId;
    kind;
    instanceId;
    constructor(input) {
        super(input.message);
        this.name = "CommandSettlementError";
        this.requestId = input.requestId;
        this.kind = input.kind;
        this.instanceId = input.instanceId;
        if (input.code) {
            this.code = input.code;
        }
    }
}
export const toCommandSettlementError = (detail) => {
    return new CommandSettlementError({
        requestId: detail.requestId,
        kind: detail.kind,
        instanceId: detail.instanceId,
        message: detail.error.message ??
            `Command ${detail.kind} failed without an error payload`,
        code: detail.error.code,
    });
};
export class CommandSettlementTimeoutError extends Error {
    code = COMMAND_SETTLEMENT_TIMEOUT_CODE;
    requestId;
    constructor(requestId) {
        super(`Timed out waiting for command settlement: ${requestId}`);
        this.name = "CommandSettlementTimeoutError";
        this.requestId = requestId;
    }
}
const eventHasDetail = (event) => typeof event === "object" && event !== null && "detail" in event;
export const waitForCommandSettlement = (input) => {
    const requestId = input.requestId;
    if (!requestId) {
        return Promise.reject(new Error("requestId must be a non-empty string"));
    }
    const targetWindow = input.windowRef ?? (typeof window === "undefined" ? undefined : window);
    if (!targetWindow) {
        return Promise.reject(new Error("Cannot await command settlement without window"));
    }
    const eventName = toHostEventName(HOST_EVENT_KEYS.INSTANCE_COMMAND_SETTLED);
    const timeoutMs = Math.max(0, input.timeoutMs ?? DEFAULT_SETTLEMENT_TIMEOUT_MS);
    return new Promise((resolve, reject) => {
        const cleanup = () => {
            if (typeof targetWindow.removeEventListener === "function") {
                targetWindow.removeEventListener(eventName, handleEvent);
            }
        };
        const timeoutId = setTimeout(() => {
            cleanup();
            reject(new CommandSettlementTimeoutError(requestId));
        }, timeoutMs);
        const handleEvent = (event) => {
            if (!eventHasDetail(event)) {
                return;
            }
            const raw = event.detail;
            if (!isCommandSettledDetail(raw) || raw.requestId !== requestId) {
                return;
            }
            const detail = raw;
            cleanup();
            clearTimeout(timeoutId);
            if (detail.ok) {
                resolve(detail);
                return;
            }
            reject(toCommandSettlementError(detail));
        };
        targetWindow.addEventListener(eventName, handleEvent);
    });
};
